import { motion } from 'framer-motion';
import { FlaskConical, Globe, Smartphone, Target } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Globe size={36} />,
      title: "Website Development",
      description: "Custom Web Applications Built to Scale",
      details: [
        "Modern, responsive, and secure web applications",
        "Full-stack solutions using Java, Spring Boot, Angular",
        "Static websites to complex enterprise platforms",
        "Scalable architecture and performance optimization"
      ]
    },
    {
      icon: <Smartphone size={36} />,
      title: "Mobile App Development",
      description: "Cross-Platform Mobile Solutions with Flutter",
      details: [
        "High-performance mobile apps using Flutter & Dart",
        "Seamless experiences on Android and iOS",
        "Startup MVPs and enterprise solutions",
        "Native features integration and optimization"
      ]
    },
    {
      icon: <FlaskConical size={36} />,
      title: "Hiring Solutions",
      description: "Structured Technical Evaluation for Fresher Hiring",
      details: [
        "Technical assessments via HackerRank",
        "Face-to-face technical interviews",
        "Resume & email screening",
        "Detailed performance reports"
      ]
    },
    {
      icon: <Target size={36} />,
      title: "Career Guidance & Support",
      description: "Training, Upskilling & Placement Readiness",
      details: [
        "Full Stack, Frontend & Backend training",
        "Resume building workshops",
        "Technical & HR mock interviews",
        "Real-world projects with certification"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="container mx-auto px-4 py-16"
      >
        {/* Hero Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20 relative"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-secondary/10 blur-3xl -z-10"></div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            Our Services
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We combine deep technical expertise with industry-focused career services to help 
            businesses grow and students succeed.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <motion.div 
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              className="group"
            >
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/5 transform group-hover:scale-105 transition-transform duration-500"></div>
                <div className="relative z-10">
                  <div className="mb-6 transform group-hover:scale-110 transition-transform duration-500 inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/8 text-primary">
                    {service.icon}
                  </div>
                  <h2 className="text-2xl font-bold text-primary mb-3 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                    {service.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6 font-medium">
                    {service.description}
                  </p>
                  <ul className="space-y-4">
                    {service.details.map((detail, i) => (
                      <motion.li
                        key={i}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.1 + i * 0.1 }}
                        className="flex items-start space-x-3"
                      >
                        <div className="bg-accent rounded-full p-1 transform group-hover:rotate-6 transition-transform duration-500">
                          <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <span className="text-gray-600">{detail}</span>
                      </motion.li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="mt-20 text-center"
        >
          <h3 className="text-3xl font-bold text-primary mb-6 bg-gradient

-to-r from-primary to-secondary bg-clip-text text-transparent">
            Let's Collaborate
          </h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Whether you're looking to build software, hire tech talent, or grow your career — 
            Vista Tech is your trusted partner.
          </p>
          
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Services;